import React, { PureComponent } from 'react';
import { scrollbarSize } from '../utils';
import styles from './Weekdays.scss';
import { shape, string, oneOfType, func, number, arrayOf } from 'prop-types'
export default class Weekdays extends PureComponent {
  static propTypes = {
    theme: shape({
      floatingNav: shape({
        background: string,
        chevron: string,
        color: string,
      }),
      headerColor: string,
      selectionColor: oneOfType([string, func]),
      textColor: shape({
        active: string,
        default: string,
      }),
      todayColor: string,
      weekdayColor: string,
    }),
    weekStartsOn: number,
    weekdays: arrayOf(string)
  };

  render() {
    const { weekdays, weekStartsOn, theme } = this.props
    const orderedWeekdays = [...weekdays.slice(weekStartsOn, 7), ...weekdays.slice(0, weekStartsOn)]
    return (
      <ul
        className={styles.root}
        style={{
          backgroundColor: theme.weekdayColor,
          color: theme.textColor.active,
          paddingRight: scrollbarSize,
        }}
        aria-hidden
      >
        {orderedWeekdays.map((val, index) => (
          <li key={`Weekday-${val}`} className={styles.day}>{val}</li>
        ))}
      </ul>
    );
  }
}
